import { Mail, MapPin, Clock } from "lucide-react";
import { motion } from "framer-motion";

export default function Contact() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <main className="min-h-screen bg-slate-900 text-white pt-32 pb-20 relative overflow-hidden selection:bg-aseBlue selection:text-white flex flex-col justify-center">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-aseBlue/10 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10 text-center w-full">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <span className="text-aseBlue font-semibold tracking-wider uppercase text-sm mb-4 block">Get In Touch</span>
          <h1 className="text-4xl md:text-5xl font-display font-bold tracking-tight mb-4">
            Let's Start a <span className="text-transparent bg-clip-text bg-gradient-to-r from-aseBlue to-purple-400">Conversation.</span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We’d love to hear from you. Whether you’re interested in working with us, exploring opportunities, or have general inquiries — our team is here.
          </p>
        </motion.div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {/* Email */}
          <motion.div variants={itemVariants} className="bg-slate-800/40 backdrop-blur-xl border border-white/5 rounded-3xl p-8 hover:border-aseBlue/30 transition-colors group">
            <div className="w-14 h-14 rounded-2xl bg-aseBlue/10 flex items-center justify-center text-aseBlue mx-auto mb-6 group-hover:scale-110 group-hover:bg-aseBlue/20 transition-all">
              <Mail className="w-6 h-6" />
            </div>
            <h4 className="font-display font-semibold text-xl mb-2 text-white">Email Us</h4>
            <a href="mailto:hr@alliedsoftwareengineers.com" className="text-gray-400 hover:text-aseBlue transition break-words">
              hr@alliedsoftwareengineers.com
            </a>
          </motion.div>

          {/* Location */}
          <motion.div variants={itemVariants} className="bg-slate-800/40 backdrop-blur-xl border border-white/5 rounded-3xl p-8 hover:border-purple-500/30 transition-colors group">
            <div className="w-14 h-14 rounded-2xl bg-purple-500/10 flex items-center justify-center text-purple-400 mx-auto mb-6 group-hover:scale-110 group-hover:bg-purple-500/20 transition-all">
              <MapPin className="w-6 h-6" />
            </div>
            <h4 className="font-display font-semibold text-xl mb-2 text-white">Headquarters</h4>
            <p className="text-gray-400">Pakistan</p>
          </motion.div>

          {/* Hours */}
          <motion.div variants={itemVariants} className="bg-slate-800/40 backdrop-blur-xl border border-white/5 rounded-3xl p-8 hover:border-blue-400/30 transition-colors group">
            <div className="w-14 h-14 rounded-2xl bg-blue-400/10 flex items-center justify-center text-blue-400 mx-auto mb-6 group-hover:scale-110 group-hover:bg-blue-400/20 transition-all">
              <Clock className="w-6 h-6" />
            </div>
            <h4 className="font-display font-semibold text-xl mb-2 text-white">Business Hours</h4>
            <p className="text-gray-400">Mon – Sat<br/>9:00 AM – 5:00 PM</p>
          </motion.div>
        </motion.div>
      </div>
    </main>
  );
}
